import {ClsPeticionPresupuestos} from './cls-pr-generico';
import {ClsContenidoBucketStorage, ClsListaArchivos} from '../cls-storage';
import {ClsErrores} from '../cls-errores';

export class ClsPeticionEnListaArchivosStorage extends ClsPeticionPresupuestos {
  NombreArchivo?: string;
  FormatoMIME?: string;
  NombreBucket: string;
  NombrePrefix: string;
  ContenidoArchivo?: any;
}

export class ClsRespuestaEnListaArchivosStorage {
  ListaArchivos: ClsListaArchivos[];
  Errores: ClsErrores;
}

export class ClsPeticionSubeArchivoStorage extends ClsPeticionEnListaArchivosStorage {

}

export  class ClsRespuestaSubeArchivoStorage {
  Resultado: string;
  Errores: ClsErrores;
}
export class ClsPeticionEliminarObtieneBucketStorage extends ClsPeticionPresupuestos {
  NombreArchivo: string;
  NombreBucket: string;
}

export class ClsRespuestaEliminarObtieneBucketStorage extends ClsPeticionPresupuestos {
  LsDatosBucket: ClsContenidoBucketStorage[];
}

export class ClsRespuestaDescargaArchivosStorage2 extends ClsPeticionPresupuestos {
  LsDatosBucket: ClsRespuestaDescargaArchivosStorage[];
  Errores: ClsErrores;
}
export class ClsRespuestaDescargaArchivosStorage {
  RutaArchivo: string;
  Enlace: string;
  ContenidoArchivo: string;
  Errores: ClsErrores;
}

/** Un ítem de subida para SubeListaDeArchivosStoragev2 (ruta relativa al id de carpeta en el servidor). */
export class ClsDatosBucketSube {
  NombrePrefix?: string;
  NombreArchivo: string;
  FormatoMIME: string;
  NombreBucket: string;
  ContenidoArchivo: string;
}

export class ClsPeticionSubeListaArchivosStorageV2 extends ClsPeticionPresupuestos {
  LsDatosBucket: ClsDatosBucketSube[];
}

export class ClsSubeArchivoItemResult {
  NombreArchivo: string;
  RutaCompleta: string;
  Errores: ClsErrores;
}

export class ClsRespuestaSubeListaArchivosStorageV2 {
  Resultado: string;
  LsDetalle: ClsSubeArchivoItemResult[];
  Errores: ClsErrores;
}
